import { SxProps, Theme } from '@mui/material';

export const audioButtonContainerStyles = (theme: Theme): SxProps<Theme> => ({
  width: '100%',
  height: '36.5px !important',
  maxHeight: '36.5px !important',
  minHeight: '36.5px !important',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  overflow: 'hidden',
  position: 'relative',
  flexShrink: 0,
  '&:hover': {
    opacity: 0.8,
  },
  '& > div': {
    width: '100% !important',
    height: '36.5px !important',
    maxHeight: '36.5px !important',
    minHeight: '36.5px !important',
    margin: '0 !important',
    overflow: 'hidden',
    flexShrink: 0,
  },
});

export const audioButtonStyles = (theme: Theme): SxProps<Theme> => ({
  width: '100%',
  height: '36.5px',
  borderRadius: '12px',
  borderColor: theme.palette.primary.main,
  color: theme.palette.primary.main,
  textTransform: 'capitalize',
  borderWidth: '2px',
  flexShrink: 0,
  '&:hover': {
    borderColor: theme.palette.primary.dark,
    backgroundColor: theme.palette.primary.light + '20',
  },
  '&:disabled': {
    borderColor: theme.palette.grey[400],
    color: theme.palette.grey[400],
  },
});
